import { useState, useEffect, useContext } from "react";
import { ApolloError, useQuery } from "@apollo/client";
import { getLanguages } from "../../api/queries/languagesAPI";
import { ILanguage } from "../../components/LanguagesDropdown/LanguagesInterfaces";
import { ILanguagesEntity } from "./LanguagesEntityInterfaces";
import { getAvailableLanguages, setAvailableLanguages } from "utilities/storageUtilities";
import { OnlineStatusContext } from "contexts/OnlineStatusContext/OnlineStatusContext";
import { LocalStorageGlobalKeys } from "constants/constants";

export const LanguagesEntity: ILanguagesEntity = {
    GetLanguages: () => {
        const { loading, error, data } = useQuery(getLanguages);
        const [languages, setLanguages] = useState<ILanguage[]>([]);
        const [apolloQueryError, setApolloQueryError] = useState<ApolloError | undefined>(undefined);
        const { onlineStatus } = useContext(OnlineStatusContext);

        useEffect(() => {
            if (onlineStatus) {
                if (data) {
                    const languagesArray: ILanguage[] = data.language;
                    setLanguages(languagesArray);
                    setAvailableLanguages(languagesArray);
                }
                if (error) {
                    setApolloQueryError(error);
                }
            } else {
                try {
                    if (localStorage.getItem(LocalStorageGlobalKeys.LANGUAGES)) {
                        const languagesArray: ILanguage[] = getAvailableLanguages()!;
                        setLanguages(languagesArray);
                        setApolloQueryError(undefined);
                    } else {
                        setApolloQueryError(error);
                    }
                } catch (error: any) {
                    setApolloQueryError(error);
                }
            }
        }, [onlineStatus, data, error]);

        return { loading, languages, apolloQueryError };
    },
};
